var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-dark-bg"},[_c('div',{attrs:{"id":"rightTwoCharts"}},[_c('div',{staticClass:"top-banner"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("map.title")))]),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t("map.desc")))])]),_c('div',{ref:"demoMap",attrs:{"id":"demoMap"}}),_c('numberAnimate')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }